import { computed, reactive } from '@vue/composition-api';
import { useZipperApi } from './useZipperApi';

export const useCampaignsResults = () => {
  const { client } = useZipperApi();

  const state = reactive({
    /**
     * @type {{date: Date, total: number}[]}
     */
    campaignsZipperRevenue: null,
    campaignsRevenue: null,
    clientsContacted: null,
    loading: true,
    error: {
      load: null,
    },
  });

  /**
   *
   * @param {string} customerId
   * @param {import("@sejazipper/layer-api-client").CampaignFilters} filters
   */
  const load = async (customerId, filters) => {
    try {
      state.loading = true;
      const [campaignsRevenue, campaignsZipperRevenue, clientsContacted] = await Promise.all([
        client.chain.query
          .campaignsRevenue({ customerId, storeIds: filters.storeIds })
          .get({ date: true, total: true }),
        client.chain.query
          .campaignsZipperRevenue({
            customerId,
            filters: { storeIds: filters.storeIds, campaignIds: filters.campaignIds },
          })
          .get({ date: true, total: true }),
        client.chain.query
          .clientsContactedByCustomerIdByStoreIds({
            customerId,
            filters: { storeIds: filters.storeIds, campaignIds: filters.campaignIds },
          })
          .get({ date: true, total: true }),
      ]);
      // work around utc-3
      const parseDate = (dateString = '') => new Date(`${dateString}-02`);
      state.campaignsRevenue = campaignsRevenue.map((el) => ({ ...el, date: parseDate(el.date) }));
      state.clientsContacted = clientsContacted.map((el) => ({ ...el, date: parseDate(el.date) }));
      state.campaignsZipperRevenue = campaignsZipperRevenue.map((el) => ({
        ...el,
        date: parseDate(el.date),
      }));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      state.error.load = e;
    } finally {
      state.loading = false;
    }
  };

  return {
    load,
    campaignsZipperRevenue: computed(() => state.campaignsZipperRevenue),
    campaignsRevenue: computed(() => state.campaignsRevenue),
    clientsContacted: computed(() => state.clientsContacted),
    loading: computed(() => state.loading),
    error: computed(() => state.error),
  };
};
